const customError = (errorMessage: string) => {
    const cleanedErrorMessage = errorMessage.replace(
        / \(and \d+ more errors?\)/,
        ""
    );

    return cleanedErrorMessage !== undefined
        ? new Error(cleanedErrorMessage)
        : new Error("予期せぬエラーが発生しました。");
};

export default customError;
